import React, { useEffect, useState } from 'react';
import { getSiteDomain } from '../../../utils/common';
import makeRequest from '../../../utils/makeRequest';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

import s from './HomePageTopLayout.scss';
import { TOI_LIVE_DOMAIN } from '../../../constants';

const RefreshStories = ({ sectionData, geoCityData, isPrime, isGccPage }) => {
  const [newStoryNumber, setNewStoryNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const getIdList = (stories = []) => {
    const idList = [];
    if (stories && stories.length > 0) {
      stories.forEach(storyObject => {
        // eslint-disable-next-line no-unused-expressions
        Array.isArray(storyObject.items) &&
          storyObject.items.forEach(story => {
            if (
              (story.ag === 'spotlight' && story.id) ||
              story.citynews === 'y'
            )
              return;
            idList.push(story.id);
          });
      });
    }
    return idList;
  };

  const compareTopStories = newStories => {
    const previousStoriesId = getIdList(sectionData.items);
    const newStoriesId = getIdList(newStories);
    const filteredArray = newStoriesId.filter(
      id => previousStoriesId.indexOf(id) === -1,
    );
    if (filteredArray.length >= 1) {
      setNewStoryNumber(filteredArray.length);
    } else {
      setNewStoryNumber(0);
    }
  };

  const refreshPage = () => {
    setNewStoryNumber(0);
    setIsLoading(true);
    window.location.reload();
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'inactive_refresh',
      label: 'New Story',
    });
  };

  const loadDataForTopStories = city => {
    if (!city) {
      return;
    }

    const dataUrl = `${getSiteDomain()}/${
      isGccPage ? 'gcc' : ''
    }webhomepagefeedspadata.cms?feedtype=sjson&istoponly=y${
      isPrime ? '&pc1=yes' : ''
    }`;

    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (data && data.data && data.data.length > 0) {
        compareTopStories(data.data);
      }
    });
  };

  useEffect(
    () => {
      let intervalID;
      if (sectionData && sectionData.id === 'topstories') {
        intervalID = setInterval(() => {
          const { city } = geoCityData || {};
          loadDataForTopStories(city);
        }, 3 * 60 * 1000);
      }

      return () => {
        if (intervalID) {
          clearInterval(intervalID);
        }
      };
    },
    [geoCityData],
  );

  return (
    <>
      {isLoading && <div className={s.refresh_loader} />}
      {newStoryNumber > 0 ? (
        <InViewObserver
          inViewCallback={() => {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: `inactive_refresh`,
              label: `${newStoryNumber === 1 ? 'Story' : 'Stories'}`,
            });
          }}
        >
          <button
            id="refresh-button"
            className={`${s.new_story_btn} ${
              typeof window !== 'undefined' && window.isStickyHeader
                ? 'sticky'
                : ''
            }`}
            onClick={refreshPage}
          >
            {`${newStoryNumber} New ${
              newStoryNumber === 1 ? 'Story' : 'Stories'
            }`}{' '}
            <img
              src={`${TOI_LIVE_DOMAIN}/photo/86578216.cms`}
              alt="refresh icon"
            />
          </button>
        </InViewObserver>
      ) : null}
    </>
  );
};

export default RefreshStories;
